import DrawerBasic, { IDrawerBasicRef } from "@/Components/Base/Drawer/DrawerBasic";
import ComponentePermissao from "@/Components/Base/Permissao/ComponentePermissao";
import { PaginaInfo } from "@/Models/Utils/Pagina/Pagina";
import { useFeriadoListar, type FeriadoListarFiltros } from "@/Services/geral/data/FeriadoService";
import { Form, Row, Input, Col, Button, InputNumber } from "antd";
import { useEffect, useRef } from "react";
import FeriadoForm from "./FeriadoForm";
import FeriadoTable from "./FeriadoTable";
import MesSelect from "../mes/MesSelect";

export type FeriadoConsultaScreenFiltros = FeriadoListarFiltros & {

}
export interface IFeriadoConsultaScreenProps {

}

export default function FeriadoConsultaScreen({

}:IFeriadoConsultaScreenProps) {
    const [form] = Form.useForm<FeriadoConsultaScreenFiltros>();
    const refNova = useRef<IDrawerBasicRef>(null);

    const filtros = Form.useWatch([], form);

    const {
        data,
        refetch,
        isLoading,
        isFetching
    } = useFeriadoListar({
        feriado : filtros?.feriado,
        mes: filtros?.mes,
        paginaInfo : filtros?.paginaInfo,
        enabled : false
    });

    useEffect(() => {
        refetch();
    }, [filtros?.paginaInfo]);

    return <div>
        <Form
            form={form}
            layout={"vertical"}
            autoComplete={"off"}
            size="small"
            initialValues={{
                paginaInfo: new PaginaInfo()
            }}
            onFinish={() => {
                refetch();
            }}
            style={{
                marginBottom : 4
            }}
        >
            <Row gutter={4} wrap justify="start" align="bottom">
                <Form.Item<FeriadoConsultaScreenFiltros> name={["paginaInfo"]} hidden label="Pagina Info">
                    <Input hidden />
                </Form.Item>
                <Col xs={24} sm={12} md={6} lg={5} xl={2} xxl={2}>
                    <Form.Item<FeriadoConsultaScreenFiltros> label="Ano" rules={[ { required: false } ]} name={["feriado", "ano"]}>
                        <InputNumber placeholder="Todos" min={2000} />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6} lg={5} xl={3} xxl={3}>
                    <Form.Item<FeriadoConsultaScreenFiltros> label="Mês" rules={[ { required: false }]} name={["mes"]}>
                        <MesSelect placeholder="Todos" />
                    </Form.Item>
                </Col>
                <ComponentePermissao permissoes={["DomainViagemFinanceiroContaViagemListar"]}>
                    <Col xs={"auto"}>
                        <Form.Item<FeriadoConsultaScreenFiltros>>
                            <Button type="primary" htmlType="submit">Listar</Button>
                        </Form.Item>
                    </Col>
                </ComponentePermissao>
                <ComponentePermissao permissoes={["DomainViagemFinanceiroContaViagemInserir"]}>
                    <Col xs={"auto"}>
                        <Form.Item<FeriadoConsultaScreenFiltros>>
                            <DrawerBasic
                                ref={refNova}
                                elementoGatilho={<Button type="dashed">Adicionar</Button>}
                                destroyOnClose={true}
                            >
                                <FeriadoForm 
                                    onCancelar={(e) => {
                                        refNova.current?.fechar(e);
                                    }}
                                    onSuccess={() => {
                                        refNova.current?.fechar({} as any);
                                        refetch();
                                    }}
                                />
                            </DrawerBasic>
                        </Form.Item>
                    </Col>
                </ComponentePermissao>
            </Row>
        </Form>

        <FeriadoTable
            dataSource={data}
            loading={isLoading || isFetching}
            onSuccess={() => {
                refetch();
            }}
            onChange={(pagina, ...restParam) => {
                form.setFieldsValue({
                    paginaInfo : {
                        pagina : pagina.current ?? 1,
                        tamanho : pagina.pageSize ?? 15
                    }
                } as any);
            }} 
        />
    </div>
}